import { IConfig } from '@cian/config/shared';
import { defaultTo } from 'ramda';

export const getTooltipText = (config: IConfig) => {
  return defaultTo('', config.get<string>('moderation.QualityLevelTooltip'));
};
